'use strict';

module.exports = () => {
	return {
		// passportPrefix: "http://localhost:7001/api/passport/",
    // baseURL: "http://127.0.0.1:7001/api",
    // publicPath: "http://localhost:7001/public",
    // resourcePath: "http://localhost:7001/api/file",
    // videoPath: "http://localhost:7001/api/video/upload",
    // videoDownloadPath: "http://localhost:7001/api/video/download"

    //On Server
    casLogin: "/api/cas/login",
    ssoLogin: "/api/sso/login",
    passportPrefix: "/api/passport/",
    baseURL: "/api",
    publicPath: "/public",
    resourcePath: "/api/file",
    videoPath: "/api/video/upload",
    videoDownloadPath: "/api/video/download",
	}
}